import React, { useState, useEffect } from "react";
import { Card, Button, TextContainer, Popover, ActionList, Text } from "@shopify/polaris";
import { ReplaceMajor } from "@shopify/polaris-icons";
import { useTranslation } from "react-i18next";

export default function LibraryThemeCard(props) {
  const { t } = useTranslation();
  const { name, key, description, image_url } = props.theme;
  const [popoverActive, setPopverActive] = useState(false);

  const themeActions = [
    {
      content: t("themes.card.publish"),
      onAction: () => props.publishTheme(key),
      icon: ReplaceMajor,
    },
  ];

  const popoverButton = (
    <Button onClick={() => setPopverActive(!popoverActive)} disclosure>
      {t("themes.card.actions")}
    </Button>
  );

  return (
    <Card sectioned>
      <Card.Section flush>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <div className="theme-preview-image-container">
            <img src={image_url} />
          </div>
          <div
            style={{
              marginLeft: "1.6em",
              marginRight: "1em",
              flex: 1,
            }}
          >
            <TextContainer>
              <Text variant="headingMd" as="h2">{name}</Text>
              <Text  variant="bodyMd" as="span" color="subdued">{description}</Text>
            </TextContainer>
          </div>
          <Popover
            active={popoverActive}
            activator={popoverButton}
            onClose={() => setPopverActive(false)}
          >
            <ActionList items={themeActions} />
          </Popover>
        </div>
      </Card.Section>
    </Card>
  );
}
// "https://miro.medium.com/max/2000/1*UzmjsSZkY4m7S_nBXMC9AQ.png"
